module.exports = __webpack_public_path__ + "static/media/IMG_1688.f5e87568.JPG";